<template>
  <div class="tzxx-warp">
    <div class="content">
      <div class="warp-header">
        <label>时间:</label>
        <div style="display: inline-block;">
          <el-date-picker
            v-model="search.dates[0]"
            type="datetime"
            placeholder="选择日期时间"
            size="small"
          ></el-date-picker>
          <label style="padding: 0px 10px;">-</label>
          <el-date-picker
            v-model="search.dates[1]"
            type="datetime"
            placeholder="选择日期时间"
            size="small"
          ></el-date-picker>
        </div>
        <label>状态</label>
        <el-select v-model="search.type" placeholder="请选择" size="small">
          <el-option value="-1" label="全部"></el-option>
          <el-option value="0" label="未读"></el-option>
          <el-option value="1" label="已读"></el-option>
        </el-select>
        <label>消息类型</label>
        <el-select v-model="search.msgType" placeholder="请选择" size="small">
          <el-option value="-1" label="全部"></el-option>
          <el-option
            v-for="(item, index) in msgType"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
        <el-button type="primary" @click="bindGetDataBySearch" size="small"
          >查询</el-button
        >
        <el-button type="primary" @click="allRead" size="small"
          >本页全部已读</el-button
        >
      </div>
      <div class="table-content">
        <div class="table-main">
          <div class="table-header">
            消息中心列表
          </div>
          <div class="table-body">
            <div
              class="table-item"
              v-for="item in tableData"
              :key="item.id"
              @click="alarmClick(item)"
              :style="{ background: theme(item) }"
            >
              <div class="alarm-state">
                <span class="title">{{ item.title }}</span>
                <span class="source">{{ item.srcUserName }}</span>
                <p class="state">
                  状态
                  <span
                    class="state-txt"
                    :style="{
                      color: item.status == '1' ? '#63a8eb' : '#f29b98',
                    }"
                    >{{ item.status == "1" ? "已读" : "未读" }}</span
                  >
                </p>
              </div>
              <div class="alarm-text">{{ item.content }}</div>
              <div class="alarm-time">{{ item.time }}</div>
            </div>
          </div>
          <div class="pagination">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageIndex ? page.pageIndex : 0"
              :page-sizes="page.pageSizes"
              :page-size="page.size"
              layout="total,  prev, pager, next,sizes"
              :total="page.total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-dialog :title="contentTitle" :visible.sync="dialogVisible" width="400px" @close="dialogVisible = false">
      <div style="padding-bottom: 20px;white-space: normal;word-break: break-all;word-wrap: break-word;">{{newContent}}</div>
    </el-dialog> -->

    <lt-msg-box
      :visible="dialogVisible"
      @cancel="dialogVisible = false"
      :showFoot="false"
      :title="selectedRow.title"
    >
      <!-- <div style="padding-bottom: 20px;white-space: normal;word-break: break-all;word-wrap: break-word;">{{selectedRow.content}}</div> -->
      <div class="box-content">
        <!-- <Event v-if="[2,3].indexOf(selectedRow.type) > -1" :msgObj="selectedRow"></Event>
        <Bill v-else-if="[4,5,6,7].indexOf(selectedRow.type) > -1" :msgObj="selectedRow"></Bill> -->
        <Default :msgObj="selectedRow"></Default>
      </div>
    </lt-msg-box>
  </div>
</template>
<script>
import { getPage } from "@/utils/index.js";
import dateTool from "@/utils/dateTool";
import { isNull } from "util";
import api from "@common/api/index.js";
import cookie from "@/utils/cookie";
import LtMsgBox from "@/components/common/LtMsgBox.vue";
import Bill from "./Bill.vue";
import Default from "./Default.vue";
import Event from "./Event.vue";
import config from "@common/config/index.js";
export default {
  components: { LtMsgBox, Default, Event, Bill },
  data() {
    return {
      msgType: config.msgType,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      search: {
        type: "-1",
        msgType: "-1",
        dates: [new Date().setDate(new Date().getDate() - 30), new Date()],
      },
      pageData: [],
      tableData: [],
      page: {
        pageSizes: [10, 20, 50, 100], //每页显示条目个数
        size: 10,
        total: 0,
        pageIndex: 1,
      },
      newContent: "",
      contentTitle: "",
      dialogVisible: false,
      selectedRow: {},
    };
  },
  created() {
    this.bindGetDataBySearch();
  },
  methods: {
    async bindGetDataBySearch() {
      this.newContent = "";
      let startDate = "",
        endDate = "";
      if (!isNull(this.search.dates) && this.search.dates.length > 1) {
        startDate = dateTool.format(
          new Date(this.search.dates[0]),
          "yyyy-MM-dd hh:mm:ss"
        );
        endDate = dateTool.format(
          new Date(this.search.dates[1]),
          "yyyy-MM-dd hh:mm:ss"
        );
        let res = await api.notifyMsg.pageNotifyMsgInfoList(
          startDate,
          endDate,
          this.search.type,
          this.search.msgType,
          this.page.size,
          this.page.pageIndex
        );
        const dataList = res.data.listData;
        let data = [];
        if (this.search.msgType == "-1") {
          data = dataList;
        } else {
          for (let i = 0; i < dataList.length; i++) {
            const element = dataList[i];
            if (element.type === this.search.msgType) {
              data.push(element);
            }
          }
        }
        // let page = getPage(data, this.page.pageIndex, this.page.size);
        // this.pageData = data;
        this.tableData = data;
        // this.page.pageIndex = page.pageIndex;
        // this.page.size = page.pageSize;
        this.page.total = res.data.totalCount;
      } else {
        this.$message({
          message: "请选择您要查询的时间段！",
          type: "warning",
        });
      }
    },
    allRead() {
      //点击全部已读
      let ids = [];
      this.tableData.forEach((item) => {
        if (item.status === 0) {
          item.status = 1;
          ids.push(item.id);
        }
      });
      this.setPage(1, this.page.size);
      this.setNotifyMsgStatusToRead(ids);
    },
    handleSizeChange(val) {
      //pageSize 改变时会触发
      this.setPage(1, val);
      this.bindGetDataBySearch();
    },
    handleCurrentChange(val) {
      //currentPage 改变时会触发
      // this.setPage(val, this.page.size);
      this.page.pageIndex = val;
      this.bindGetDataBySearch();
    },
    setPage(val, pageSize) {
      //设置页面状态信息
      let page = getPage(this.pageData, val, pageSize);
      this.tableData = page.data;
      this.page.pageIndex = page.pageIndex * 1;
      this.page.size = page.pageSize * 1;
      this.page.total = page.total * 1;
    },
    async alarmClick(row) {
      //点击某条告警时触发
      // this.contentTitle = row.title;
      // this.newContent = row.content;
      this.selectedRow = row;
      this.dialogVisible = true;
      if (row.status == "1") {
        //如果是未读状态
        return;
      }
      let res = await api.notifyMsg.setNotifyMsgStatusToRead(
        JSON.stringify([row.id])
      ); //进行更改为已读
      if (res) {
        row.status = 1;
        this.$store.commit(
          "data/SET_NOTIFY_MSG_TOTAL",
          this.$store.state.data.notifyMsgTotal - 1
        );
      }
    },
    async setNotifyMsgStatusToRead(ids) {
      //设置已读  ids设置已读的行
      let res = await api.notifyMsg.setNotifyMsgStatusToRead(
        JSON.stringify(ids)
      );
      if (res) {
        api.notifyMsg.getUnReadNotifyMsgCount().then((res) => {
          this.$store.commit("data/SET_NOTIFY_MSG_TOTAL", res.data || 0);
        });
        this.bindGetDataBySearch();
        this.$message({
          message: res.errorStr,
          type: "success",
        });
      }
    },
  },
  computed: {
    theme() {
      return (item) => {
        let bgColor = "#f1f2f4";
        let otColor = "#d6d7d9";
        if (cookie.getCookie("theme") != "theme-defalt") {
          //暗黑主题
          bgColor = "#161e33";
          otColor = "#0b0f19";
        }
        if (item.status == "0") {
          //未读
          bgColor = otColor;
        }
        return bgColor;
      };
    },
  },
};
</script>
<style scoped lang="scss">
.tzxx-warp {
  font-size: 14px;
  padding: 23px;
  box-sizing: border-box;
  height: 100%;
  .content {
    width: 100%;
    height: 100%;
    position: relative;
    .warp-header {
      height: 52px;
      width: 100%;
      border-radius: 4px;
      background: #fff;
      text-align: left;
      display: flex;
      align-items: center;
      margin-bottom: 14px;
      label {
        padding: 0px 10px;
        color: #585858;
      }
      .el-select {
        width: 120px;
      }
      .el-button {
        margin-left: 10px;
      }
    }
    .table-content {
      width: 100%;
      box-sizing: border-box;
      position: absolute;
      bottom: 0;
      width: 100%;
      top: 66px;
      background: #fff;
      border-radius: 4px;
      padding: 10px;
      .table-main {
        width: 100%;
        height: 100%;
        position: relative;
        .table-header {
          width: 100%;
          height: 44px;
          background: #63a8eb;
          border: 1px solid #63a8eb;
          border-bottom: none;
          box-sizing: border-box;
          border-radius: 4px 4px 0 0;
          font-size: 18px;
          font-weight: bold;
          line-height: 44px;
          text-align: left;
          padding-left: 10px;
        }
        .table-body {
          width: 100%;
          position: absolute;
          top: 44px;
          bottom: 40px;
          border: 1px solid #dedee1;
          box-sizing: border-box;
          padding: 0 14px 14px;
          overflow-y: auto;
          border-bottom: none;
          .table-item {
            width: 100%;
            height: auto;
            padding: 15px;
            box-sizing: border-box;
            background: #f1f2f4;
            border-radius: 4px;
            margin-top: 15px;
            cursor: pointer;
            .alarm-state {
              font-size: 14px;
              font-weight: bold;
              display: flex;
              height: 25px;
              align-items: center;
              .title {
                color: #0a97ed;
                margin-right: 25px;
              }
              .source {
                width: auto;
                display: inline-block;
                height: 25px;
                border-radius: 4px;
                background: #fff;
                padding: 0 10px;
                box-sizing: border-box;
                line-height: 25px;
                color: #585858;
                margin-right: 25px;
              }
              .state {
                color: #87888a;
                margin-right: 5px;
                .state-txt {
                  width: auto;
                  display: inline-block;
                  height: 25px;
                  border-radius: 4px;
                  background: #fff;
                  padding: 0 10px;
                  box-sizing: border-box;
                  line-height: 25px;
                }
              }
            }
            .alarm-text {
              color: #87888a;
              text-align: left;
              margin: 10px 0;
              overflow: hidden;
              white-space: break-spaces;
              letter-spacing: 1.5px;
            }
            .alarm-time {
              color: #87888a;
              text-align: left;
            }
          }
        }
        .pagination {
          position: absolute;
          bottom: 3px;
          width: 100%;
          text-align: right;
          border: 1px solid #dedee1;
          border-radius: 0 0 4px 4px;
          border-top: none;
          box-sizing: border-box;
          padding-top: 5px;
        }
      }
    }
  }
}
.theme-dark {
  .tzxx-warp {
    .content {
      background: #1e2432;
      .warp-header {
        background: #030a1d;
      }
      .table-content {
        background: #030a1d;
        .table-main {
          .table-header {
            background: #303749;
            border-color: #303749;
          }
          .table-body {
            border-color: #373e51;
            .table-item {
              background: #161e33;
              .alarm-state {
                .source {
                  background: #303749;
                }
                .state {
                  .state-txt {
                    background: #303749;
                  }
                }
              }
            }
          }
          .pagination {
            border-color: #373e51;
          }
        }
      }
    }
  }
}
.box-content {
  width: 600px;
  padding: 0px 10px;
}
</style>
